
    import { defineComponent, PropType } from "vue";

    export interface ITab {
        label: string;
        value: string;
    }

    export default defineComponent({
        props: {
            tabs: Object as PropType<ITab[]>,
            value: String,
        },
        components: {},
        data() {
            return {
                hash: window.location.hash,
            };
        },
        computed: {},
        methods: {
            handleChangeTab(value: string) {
                this.$emit("update:value", value);
                window.location.hash = value;
            },
        },

        watch: {
            // hash: {
            //     handler(newVal: string) {
            //         const hash = newVal;
            //         this.$emit("update:value", hash?.replace("#", "") || "");
            //     },
            //     immediate: true,
            //     deep: true,
            // }
        },

        created () {
            const hash = window.location.hash;
            this.$emit("update:value", hash?.replace("#", "") || "");
        },
    });
